import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';

import useSteps from '../useSteps';

// Icons
import Check from '../../../../icons/check.svg';

// Components
import Heading from '../../../../components/Heading';

// Styles
import styles from './Steps.styl';

const cx = classNames.bind(styles);

export default function Steps(props) {
  const {
    orderData: { order_status },
  } = props;

  const intl = useIntl();
  const { statuses } = useSteps(props);

  return (
    <div className={cx('Steps')}>
      {Number(order_status) === 6 ? (
        <Heading level={5}>{intl.formatMessage({ id: 'orderHistory.status.excellent' })}</Heading>
      ) : (
        statuses.map(({ id, text, icon, isPrevious, isActive }, i) => {
          const getIcon = () => {
            if (isPrevious || (isActive && statuses[statuses.length - 1] === i)) {
              return <Check className={cx('Step__check')} />;
            }

            if (isActive) {
              return <div className={cx('Step__loader')} />;
            }

            return null;
          };

          const Icon = icon;

          return (
            <div
              key={id}
              className={cx('Step', { Step_previous: isPrevious }, { Step_active: isActive })}
            >
              <Icon className={cx('Step__icon')} />
              <Heading className={cx('Step__name')} level={4}>
                <div className={cx('Step__line', 'Step__line_left')} />
                {intl.formatMessage({ id: text })}
                {getIcon()}
                <div className={cx('Step__line', 'Step__line_right')} />
              </Heading>
            </div>
          );
        })
      )}
    </div>
  );
}

Steps.propTypes = {
  orderData: PropTypes.object.isRequired,
};
